import type { CopyShape } from "@tami/core/intl";

import type { CALCULATOR_SCRIPT_COPY_PT_BR } from "../calculator-script.copy";
import { formatCurrency } from "@tami/core/intl";

export const CALCULATOR_SCRIPT_COPY_EN_US: CopyShape<typeof CALCULATOR_SCRIPT_COPY_PT_BR> = {
  calcIntro: {
    narrative:
      "Brand deal calculator: price your deliverables with confidence, save strategies and reuse them when the offer comes in.",
  },
  calcToolbar: {
    narrative:
      "Search saved calculations, hide amounts on screen and start a new one whenever you want to try another mix of deliverables.",
    callout: "Search by name, control whether amounts are visible and create a new calculation in one click.",
  },
  calcOverview: {
    narrative: "Every strategy is saved with a title, suggested rate and last-updated date.",
  },
  calcCards: {
    narrative:
      "See the suggested rate for each brand deal at a glance — ready to send to the brand or turn into a campaign.",
    callout: "Cards with the rate, a suggested-amount badge and update history.",
  },
  calcCardValue: {
    narrative: "The total rate factors in deliverables, production time and margin — no manual spreadsheet.",
    callout: "Suggested rate calculated from the settings of your brand deal strategy.",
  },
  calcNew: {
    narrative: "New calculation opens the full simulator: networks, formats, timelines and margin — all adjustable.",
    callout: "+ New calculation — build a proposal from scratch or duplicate an existing one.",
  },
  calcModalOpen: {
    narrative:
      "The calculator opens in a modal: fill in your profile, deliverables and extras while the amount updates live.",
    callout: "New pricing — the full simulator without leaving your list of calculations.",
  },
  calcModalTitle: {
    narrative: "Name the calculation — collab, monthly package or one-off proposal, easy to find later.",
    callout: "Name the strategy — e.g., Summer fashion collab.",
  },
  calcModalProfile: {
    narrative: "Niche and years in the game go into the math — Tãmi adjusts the price range to your profile.",
    callout: "Creator profile: niche and experience shape the minimum, average and maximum.",
  },
  calcModalDeliverables: {
    narrative: "Enter networks, followers and how many reels or stories are included — the scope sets the base rate.",
    callout: "Deliverables per network — reels, stories and other formats you can configure.",
  },
  calcModalExtras: {
    narrative: "Exclusivity, paid boosting and extra costs move the proposal up or down instantly.",
    callout: "Extras like exclusivity are factored in automatically.",
  },
  calcModalResult: {
    narrative: "Minimum, average and maximum show up at the top — see the suggested range before sending it to the brand.",
    get callout(): string {
      return `${formatCurrency(2709)} on average — the full range stays visible while you tweak the fields.`;
    },
  },
  calcModalSave: {
    narrative: "Save the pricing and reuse it when the offer comes in — or turn it straight into a campaign.",
    callout: "Save pricing — copy, export or keep it in your calculation library.",
  },
};
